import { useEffect } from "react";
import stitches from "../theme.config.es.js";
import features from "./features/index.es.js";
const styles = stitches.globalCss({
  html: {
    boxSizing: "border-box"
  },
  body: {
    "-moz-osx-font-smoothing": "grayscale",
    "-webkit-font-smoothing": "antialiased",
    color: "$black100",
    fontFamily: "$defaultFont",
    fontSize: "$text",
    margin: 0
  },
  "*, *:before, *:after": {
    boxSizing: "inherit"
  }
});
const EzGlobalStyles = () => {
  styles();
  useEffect(() => {
    features.forEach(([feature, detect]) => {
      if (!detect()) document.body.classList.add(`no-${feature}`);
    });
  }, []);
  return null;
};
export {
  EzGlobalStyles as default
};
//# sourceMappingURL=EzGlobalStyles.es.js.map
